async function request(url, options = {}, authenticated = true) {
  const sessionToken = localStorage.getItem('nacanaca-session') || '';
  if (authenticated && !sessionToken) throw new Error('Inicia sesión para continuar.');
  const response = await fetch(url, {
    ...options,
    headers: {
      Accept: 'application/json',
      ...(authenticated ? { Authorization: `Bearer ${sessionToken}` } : {}),
      ...(options.body ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
  });
  const payload = await response.json().catch(() => ({ error: 'El servidor devolvió una respuesta inválida.' }));
  if (!response.ok) {
    const error = new Error(payload.error || `El servidor respondió ${response.status}.`);
    error.status = response.status;
    error.code = payload.code;
    throw error;
  }
  return payload;
}

export const createChallenge = () => request('/api/challenges', { method: 'POST', body: '{}' });
export const fetchChallengeInvite = (token) => request(`/api/challenges/invite?token=${encodeURIComponent(token)}`, {}, false);
export const claimChallenge = (token) => request('/api/challenges/claim', { method: 'POST', body: JSON.stringify({ token }) });
export const fetchChallenges = ({ limit = 25, cursor = '' } = {}) => request(
  `/api/challenges/sent?limit=${encodeURIComponent(limit)}${cursor ? `&cursor=${encodeURIComponent(cursor)}` : ''}`,
);
